import { useEffect } from "react";

let sharedLenis = null;

export function getLenis() {
  return sharedLenis;
}

export default function useLenisScroll() {
  useEffect(() => {
    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const coarsePointer =
      typeof window !== "undefined" &&
      window.matchMedia("(pointer: coarse)").matches;

    const touchDevice =
      typeof navigator !== "undefined" &&
      navigator.maxTouchPoints > 0;

    // Phones/tablets use native scrolling and never download Lenis.
    if (prefersReduced || coarsePointer || touchDevice || window.innerWidth < 1024) {
      sharedLenis = null;
      return;
    }

    let cancelled = false;
    let lenis = null;
    let rafId = 0;

    const start = async () => {
      const { default: Lenis } = await import("lenis");
      if (cancelled) return;

      lenis = new Lenis({
        duration: 1.15,
        lerp: 0.1,
        wheelMultiplier: 1,
        smoothWheel: true,
      });

      sharedLenis = lenis;

      const raf = (time) => {
        if (cancelled || !lenis) return;
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };

      rafId = requestAnimationFrame(raf);
    };

    start();

    return () => {
      cancelled = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (lenis) lenis.destroy();
      if (sharedLenis === lenis) sharedLenis = null;
    };
  }, []);
}
